<template>
  <div class="ob-subnavigation" :style="{
      position: sticky ? 'sticky' : 'unset',
      zIndex
    }"
  >
    <div class="subnav-container">
      <slot name="title">
        <span class="nav-title" @click="onBack">{{ title || route.meta.pageTitle }}</span>
      </slot>
      <slot name="tabs">
        <dl class="nav-tabs">
          <template v-for="(tab, index) in tabs" :key="tab.name">
            <dt :class="{
                'active-tab': active === tab.name
              }"
              @click="onSwitchTab(tab)"
              v-if="!tab.hidden"
            >
              <slot name="tabEvent" v-if="tab.hasTabEvent"></slot>
              <span v-else>{{ tab.title }}</span>
              <div v-if="active === tab.name" class="active-line"></div>
            </dt>
          </template>
        </dl>
      </slot>
      <slot name="cta">
        <div class="cta-slot" v-if="buttonList.length && btnVisible">
          <ObButton
            v-for="(btn, index) in buttonList"
            :key="index"
            :backgroundColor="btn.backgroundColor || (!(index%2) ? 'var(--color-state-default)' : 'var(--color-background-primary)')"
            :fontColor="btn.color || (!(index%2) ? 'var(--color-text-whitePrimary)' : 'var(--color-text-primary)')"
            :text="btn.text"
            @click="onClickBtn(btn)"
          />
        </div>
        <div class="cta-slot" v-else></div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useSystemStore } from '@/stores/system'
// import { useNavigationStore } from '@/stores/navigation'
import { getCurrentInstance } from 'vue';

const emits = defineEmits(['onSwitch', 'update:active'])
const props = defineProps({
  active: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    defualt: ''
  },
  tabs: {
    type: Array,
    defualt: () => {
      return []
    }
  },
  btnVisible: {
    type: Boolean,
    default: true
  },
  buttonList: {
    type: Array,
    default: () => {
      return []
    }
  },
  // scrollAnimation: {
  //   type: Boolean,
  //   default: false
  // },
  sticky: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: [String, Number],
    default: 20
  },
  logoCallback: {
    type: Function,
  },
})

const route = useRoute()
const router = useRouter()
const systemStore = useSystemStore()
const { isApp } = storeToRefs(systemStore)
const { proxy } = getCurrentInstance()


function onSwitchTab (tab) {
  emits('update:active', tab.name)
  emits('onSwitch', {
    name: tab.name,
    tab
  })
}

function onClickBtn ({ link, callback}) {
  if (callback) {
    callback()
    return
  }
  if (isApp.value) {

  } else {
    window.open(link)
  }
}

function onBack () {
  if (props.logoCallback) {
    props.logoCallback()
    return
  }
  if (isApp.value) {
    proxy.$goBack()
  } else {
    router.back()
  }
}

function onScroll () {
  if (document.documentElement.scrollTop) {
    if (document.querySelector('.notice')) {
      document.querySelector('.notice').style.position = 'relative'
    }
    document.querySelector('.ob-nav').style.position = 'relative'
  } else {
    if (document.querySelector('.notice')) {
      document.querySelector('.notice').style.position = 'sticky'
    }
    document.querySelector('.ob-nav').style.position = 'sticky'
  }
}

onActivated(async () => {
  if(props.sticky){
    window.addEventListener('scroll', onScroll);
  }
})

onDeactivated(() => {
  window.removeEventListener('scroll', onScroll)
})

onMounted(() => {
  if(props.sticky){
    window.addEventListener('scroll', onScroll);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll);
});

</script>

<style lang="postcss" scoped>
.ob-subnavigation {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 52px;
  background-color: var(--color-background-primary);
  box-shadow: 0px 1px 0px 0px var(--color-border-default);
  top: 0;
}
.subnav-container {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 64px;
  box-sizing: border-box;
}

.nav-title {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: 'orbit-M';
  cursor: pointer;
  height: 52px;
  color: var(--color-text-primary);
}

.nav-tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 40%;
  height: 100%;
  margin: 0 auto;
  dt {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: fit-content;
    height: 100%;
    font-size: 16px;
    letter-spacing: .32px;
    margin: 0;
    padding: 0 16px;
    color: var(--color-text-description);
    cursor: pointer;
    span {
      flex: 1;
      display: flex;
      align-items: center;
    }
    &:last-child {
      margin: 0;
    }
  }
  .active-tab {
    color: var(--color-text-primary);
  }
  .active-line {
    width: 0px;
    height: 2px;
    background-color: var(--color-text-primary);
    animation: spread .3s forwards;
  }
}

.cta-slot {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  /* min-width: 100px; */
  height: 52px;
  :deep(.ob-button) {
    height: 36px;
    padding: 9.5px 16px;
    font-size: 14px;
    min-width: 70px;
    &+.ob-button {
      /* margin-right: 12px; */
      margin-left: 12px;
    }
    /* &:nth-child(even) {
      background-color: transparent;
      color: var(--color-text-primary);
      border-color: var(--color-text-primary);
    }
    &:nth-child(odd) {
      background-color: var(--color-state-default);
      color: var(--color-text-whitePrimary);
    } */
  }
}

/* .ob-button {
  height: 36px;
  padding: 9.5px 16px;
  &:nth-child(odd) {
    background-color: transparent;
    color: var(--color-text-primary);
    border-color: var(--color-text-primary);
  }
  &:nth-child(even) {
    background-color: var(--color-state-default);
    color: var(--color-text-whitePrimary);
  }
} */

@keyframes spread {
  0% {
    width: 0px;
  }
  100% {
    width: 100%;
  }
}


</style>